import React, { useState } from "react";
import { profileData } from "../data/mock";
import { Mail, Phone, Linkedin, Copy, Check, ExternalLink } from "lucide-react";

const ContactItem = ({ icon: Icon, label, value, href, external }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigator.clipboard.writeText(value).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="group flex items-center gap-4 p-5 rounded-xl border border-slate-100 hover:border-teal-100 hover:bg-teal-50/30 transition-all duration-300">
      <div className="w-11 h-11 rounded-lg bg-slate-50 group-hover:bg-teal-50 flex items-center justify-center text-slate-400 group-hover:text-teal-600 transition-all shrink-0">
        <Icon size={20} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-xs text-slate-400 uppercase tracking-wide">{label}</p>
        <a
          href={href}
          target={external ? "_blank" : undefined}
          rel={external ? "noopener noreferrer" : undefined}
          className="text-sm font-medium text-slate-700 hover:text-teal-600 transition-colors flex items-center gap-1.5"
        >
          {value}
          {external && <ExternalLink size={12} className="text-slate-400" />}
        </a>
      </div>
      <button
        onClick={handleCopy}
        className={`p-2 rounded-lg border transition-all duration-200 shrink-0 ${
          copied
            ? "bg-teal-50 border-teal-200 text-teal-600"
            : "bg-white border-slate-200 text-slate-400 hover:text-slate-600 hover:border-slate-300"
        }`}
        title={copied ? "Copied!" : "Copy to clipboard"}
      >
        {copied ? <Check size={14} /> : <Copy size={14} />}
      </button>
    </div>
  );
};

const Contact = () => {
  return (
    <section id="contact" className="py-14 lg:py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl mb-12 lg:mb-16">
          <p className="text-sm font-medium text-teal-600 tracking-wide uppercase mb-2">
            Let's Connect
          </p>
          <h2 className="font-serif text-3xl lg:text-4xl font-bold text-slate-900 tracking-tight">
            Get in Touch
          </h2>
          <p className="mt-3 text-slate-500 leading-relaxed">
            Interested in discussing opportunities? I'd love to hear from you.
          </p>
        </div>

        <div className="max-w-lg space-y-4">
          <ContactItem
            icon={Mail}
            label="Email"
            value={profileData.email}
            href={`mailto:${profileData.email}`}
          />
          <ContactItem
            icon={Phone}
            label="Phone"
            value={profileData.phone}
            href={`tel:${profileData.phone}`}
          />
          <ContactItem
            icon={Linkedin}
            label="LinkedIn"
            value="linkedin.com/in/lpace1"
            href={profileData.linkedin}
            external
          />
        </div>
      </div>
    </section>
  );
};

export default Contact;
